/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DealClosedReasonEnum {
    ClosedPrematurely = 'CLOSED_PREMATURELY',
    ClosedEnforcement = 'CLOSED_ENFORCEMENT',
    ClosedDuly = 'CLOSED_DULY',
    ClosedAfterLiquidation = 'CLOSED_AFTER_LIQUIDATION',
    ClosedAfterInsolvency = 'CLOSED_AFTER_INSOLVENCY',
    ClosedMovedToThirdParty = 'CLOSED_MOVED_TO_THIRD_PARTY',
    ClosedMovedToHc = 'CLOSED_MOVED_TO_HC',
    ClosedDebtorDeathNoSuccesor = 'CLOSED_DEBTOR_DEATH_NO_SUCCESOR',
    ClosedDealWriteOff = 'CLOSED_DEAL_WRITE_OFF',
    ClosedRefinanced = 'CLOSED_REFINANCED',
    ClosedPropertySold = 'CLOSED_PROPERTY_SOLD',
    ClosedPropertyPurchased = 'CLOSED_PROPERTY_PURCHASED',
    ClosedPropertyNotPurchased = 'CLOSED_PROPERTY_NOT_PURCHASED',
    ClosedLeaseFinished = 'CLOSED_LEASE_FINISHED',
    ClosedLeaseForcedEviction = 'CLOSED_LEASE_FORCED_EVICTION',
    Other = 'OTHER'
}

export function DealClosedReasonEnumFromJSON(json: any): DealClosedReasonEnum {
    return DealClosedReasonEnumFromJSONTyped(json, false);
}

export function DealClosedReasonEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealClosedReasonEnum {
    return json as DealClosedReasonEnum;
}

export function DealClosedReasonEnumToJSON(value?: DealClosedReasonEnum | null): any {
    return value as any;
}

